// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Af67","newExpiryDate":"styles_newExpiryDate__2p2ew","footer":"styles_footer__1zkPf"};